import React from "react";
import { injectIntl } from 'react-intl';
import { Select } from "antd";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { history } from "../../store/_store";

import "./AuthContainer.scss";

import SignInForm from "../AuthScreens/Signin";
import SignUpForm from "../AuthScreens/Signup";
import ResetForm from "../AuthScreens/Reset";
import AuthAside from "../AuthScreens/Aside";
import Invitation from "../AuthScreens/Invitation";
import Verification from "../AuthScreens/Verification";
import CreateAccount from '../AuthScreens/CreateAccount';
import ChooseAccount from '../AuthScreens/ChooseAccount';

class AuthContainer extends React.Component {

  render() {
    const { _utils } = this.props;

    return (
      <Router>
        <ConnectedRouter history={history}>
          <div className="authWrapper">
            <div className="authWrapper__Body">
              <div className="authWrapper__FormCard">
                <AuthAside {...this.props} />
                <div className="authWrapper__FormCardRight">
                  <div className="formContainer">

                    <Switch>
                      {/* ::: auth */}
                      <Route exact path="/:lang/signin" render={() => <SignInForm {...this.props} />} />
                      <Route exact path="/:lang/signup" render={() => <SignUpForm {...this.props} />} />
                      <Route exact path="/:lang/reset" render={() => <ResetForm {...this.props} />} />
                      <Route exact path="/:lang/reset/:token" render={(props) => <ResetForm {...props} {...this.props} />} />
                      <Route exact path="/:lang/create-account" render={() => <CreateAccount {...this.props} />} />
                      <Route exact path="/:lang/choose-account" render={() => <ChooseAccount {...this.props} />} />
                      <Route exact path="/:lang/invitation/:token" render={(props) => <Invitation {...props} {...this.props} />} />
                      <Route exact path="/:lang/verification/:token" render={(props) => <Verification {...props} {...this.props} />} />

                      <Redirect to={`/${_utils.lang}/signin`} />
                    </Switch>

                  </div>
                  <div style={{ textAlign: 'center', marginTop: '10%', fontSize: 13, width: '40%', marginLeft: '13%' }}>
                    <Select className="switch__lang" defaultValue={_utils.lang} size="small" sso-id="language-switcher" style={{ color: '#eee' }} onChange={(lang) => { this.props.setLang(lang); }}>
                      <Select.Option value="en">English</Select.Option>
                      <Select.Option value="fr">Français</Select.Option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ConnectedRouter>
      </Router>
    );
  }
}

export default injectIntl(AuthContainer);